import { Spinner } from '@wartek-id/spinner'

import {
  useAPIContentKinerjaUtama,
  useAPIContentPerilakuKerja,
} from 'api/kinerja/useAPIKinerjaKS'
import { ContentContext } from 'app/KinerjaKSPage/hooks/useContentContext'
import { InternalServerError } from 'utils/customError'
import useDemoContext from 'app/KinerjaPage/hooks/useDemoContext'
import useKinerjaTipeContext from 'app/KinerjaShared/hooks/useKinerjaTipeContext'

import type {
  KinerjaKsKepemimpinanSatuanPendidikan,
  KinerjaKsUtamaDetail,
} from 'types/kinerja-ks'
import type { Jenjang, KinerjaRoleType } from 'types/kinerja'

interface ContentContextProps {
  jenjang: Jenjang | 'UNDEFINED'
  children: React.ReactNode
  isSkpFetched?: boolean
  role?: KinerjaRoleType
}

export default function ContentProvider({
  jenjang,
  children,
  isSkpFetched = false,
  role,
}: ContentContextProps) {
  if (isSkpFetched && !jenjang) {
    throw new InternalServerError('/', new Error('Jenjang tidak ditemukan'))
  }

  const { isDemoMode } = useDemoContext()
  const { tipe } = useKinerjaTipeContext()

  const {
    data: {
      data: {
        kepemimpinanSatuanPendidikan: contentKepemimpinanSatuanPendidikan = [],
        pengembanganKompetensi: contentPengembanganKompetensi = [],
        rencanaHasilKerjaEkstra: contentRencanaHasilKerjaEkstra = [],
      } = {},
    } = {},
    isFetched: isContentKinerjaUtamaFetched,
  } = useAPIContentKinerjaUtama(
    {
      jenjang,
      role,
      tipe,
    },
    { enabled: isSkpFetched, isDemoMode }
  )

  const {
    data: { data: contentPerilakuKerja } = {},
    isFetched: isContentPerilakuKerjaFetched,
  } = useAPIContentPerilakuKerja({ isDemoMode, role, tipe })

  const getKepemimpinanSatuanPendidikanById = (
    id: KinerjaKsKepemimpinanSatuanPendidikan['id']
  ): KinerjaKsKepemimpinanSatuanPendidikan => {
    return contentKepemimpinanSatuanPendidikan.find(
      (kinerja) => kinerja.id === id
    )
  }

  const getPengembanganKompetensiById = (
    id: KinerjaKsUtamaDetail['id']
  ): KinerjaKsUtamaDetail => {
    return contentPengembanganKompetensi.find((kinerja) => kinerja.id === id)
  }

  return !(
    isSkpFetched &&
    isContentKinerjaUtamaFetched &&
    isContentPerilakuKerjaFetched
  ) ? (
    <div className="flex p-10">
      <div className="m-auto">
        <Spinner data-testid="loading-spinner-content-provider" />
      </div>
    </div>
  ) : (
    <ContentContext.Provider
      value={{
        contentKepemimpinanSatuanPendidikan,
        contentPengembanganKompetensi,
        contentRencanaHasilKerjaEkstra,
        contentPerilakuKerja,
        getKepemimpinanSatuanPendidikanById,
        getPengembanganKompetensiById,
      }}
    >
      {children}
    </ContentContext.Provider>
  )
}
